<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->

    <div class="logo">
      <div style="display: flex; align-items: center">
        <img class="img-title" src="~@/assets/logo-white.png" alt="logo" style="height: 32px" />
        <h1 style="margin: 0 0 0 5px; color: white">金牌厨柜</h1>
        <h3 style="margin: 9px 0 0 10px; color: white">访客系统</h3>
      </div>
      <div class="action">
        <a-avatar class="avatar" size="small" :src="getAvatar()" />
        <span style="position: relative; top: 2px; left: 5px">用户名：{{ nickname() }}</span>
      </div>
    </div>
    <!-- <div class="header" :class="theme">
      <a-icon
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggle"
      />

      <span>欢迎进入金牌厨柜GIS管理系统</span>

    <div class="action" style="margin: 4px 0 0 60px;">
      <a-avatar class="avatar" size="small" :src="getAvatar()"/>
      <span style="position: relative;top: 2px;left: 5px;">欢迎您，{{ nickname() }}</span>
    </div>
    </div> -->
    <div class="table-page-search-wrapper" style="display: flex">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div class="div-query-banner">
          <!-- <a-form-item label="访客状态">
            <j-dict-select-tag v-model="queryParam.docstatus"
                               :triggerChange="false"
                               dictCode="visitor_hd_status"
                               :selectClear="true"></j-dict-select-tag>
          </a-form-item> -->

          <a-range-picker class="range-picker lianedate" @change="changeDate" :value="showDate">
            <template slot="renderExtraFooter"></template>
          </a-range-picker>
          <a-button class="query-banner-btn" type="primary" @click="searchQueryToday" icon="search">今日</a-button>
          <a-radio-group
            v-model="queryParam.docstatus"
            defaultValue=""
            class="radio_group"
            button-style="solid"
            @change="loadData(1)"
          >
            <a-radio-button value=""> 全部 </a-radio-button>
            <a-radio-button value="50"> 已预约 </a-radio-button>
            <a-radio-button value="150"> 已签到 </a-radio-button>
            <a-radio-button value="200"> 已离开 </a-radio-button>
          </a-radio-group>
          <!-- <a-form-item label="访客类型">
            <j-dict-select-tag v-model="queryParam.doctype"
                               :triggerChange="false"
                               dictCode="visitor_hd_doctype"
                               :selectClear="true"></j-dict-select-tag>
          </a-form-item> -->
          <a-form-item label="访客姓名">
            <j-input v-model="queryParam.bkname"></j-input>
          </a-form-item>
          <a-form-item label="访客电话">
            <j-input v-model="queryParam.bktel"></j-input>
          </a-form-item>
          <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
            >重置</a-button
          >
          <!-- <a-form-item label="接待人">
            <j-input v-model="queryParam.jdname"></j-input>
          </a-form-item>
          <a-form-item label="接待人电话">
            <j-input v-model="queryParam.jdtel"></j-input>
          </a-form-item>
          <a-form-item label="接待位置">
            <j-input v-model="queryParam.place"></j-input>
          </a-form-item>
          <a-form-item label="拜访原因">
            <j-input v-model="queryParam.whystr"></j-input>
          </a-form-item>
          <a-form-item label="取消原因">
            <j-input v-model="queryParam.cancelmemo"></j-input>
          </a-form-item> -->
          <a-form-item label="输入核销码">
            <j-input v-model="queryParam.visitorCode"></j-input>
          </a-form-item>
          <a-button class="query-banner-btn" type="primary" @click="checkVisitorCode">核销</a-button>
          <!-- <a-button class="query-banner-btn"
                    type="primary"
                    @click="signIn"
                    v-if="signInFlag"
                    >签到</a-button>
          <a-button class="query-banner-btn"
                    type="primary"
                    @click="signOut"
                    v-if="signOutFlag"
                    >签离</a-button> -->
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <div>
        <a-button @click="handleAdd"
                  type="primary"
                  icon="plus">新增访客</a-button>
        <a-button style="margin-left: 8px"
                  @click="handleCancelClick">取消拜访</a-button>
      </div>

      <a-upload name="file"
                :multiple="true"
                :action="importExcelUrl"
                :headers="headers"
                @change="handleChange">
        <a-button>
          <a-icon type="upload" /> 导入访客信息
        </a-button>
      </a-upload>
      <a-button style="margin-left: 8px"
                @click="downloadTemplate">下载模板</a-button>

    </div> -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="rowSelection"
        :scroll="{ x: true }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEditNew(record)">查看详情</a>
        </span>
      </a-table>
    </div>
    <visitor-modal ref="modalForm" @ok="modalFormOk"></visitor-modal>
    <a-modal
      title="取消原因"
      :visible="crModalvisible"
      :confirm-loading="crConfirmLoading"
      @ok="handleCROk"
      @cancel="handleCRCancel"
    >
      <a-input v-model="cancelReason" placeholder="请输入取消原因！"></a-input>
    </a-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from './components/JeecgListMixin'
import VisitorModal from './modules/VisitorModal'
import JInput from '@/components/jeecg/JInput.vue'
import { cancelVistors, ajaxGetDictItems } from '@/api/api.js'
import { getVisitorConfigList, getUserAuthority } from '@/api/api.js'
import { mapMutations, mapGetters } from 'vuex'
import { getAction } from '@/api/manage'
import Vue from 'vue'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
const token = Vue.ls.get(ACCESS_TOKEN)
export default {
  name: 'VisitorListMenGang',
  mixins: [JeecgListMixin],
  components: {
    VisitorModal,
    JInput,
  },
  data() {
    return {
      description: '访客表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'states',
        },
        {
          title: '拜访类型',
          align: 'center',
          dataIndex: 'doctype',
        },
        {
          title: '拜访时间',
          align: 'center',
          dataIndex: 'docdate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '宾客名',
          align: 'center',
          dataIndex: 'bkname',
        },
        {
          title: '电话',
          align: 'center',
          dataIndex: 'bktel',
        },
        {
          title: '验证码',
          align: 'center',
          dataIndex: 'checkstr',
        },
        {
          title: '接待人',
          align: 'center',
          dataIndex: 'jdname',
        },
        {
          title: '接待电话',
          align: 'center',
          dataIndex: 'jdtel',
        },
        {
          title: '接待位置',
          align: 'center',
          dataIndex: 'place',
        },
        {
          title: '拜访原因',
          align: 'center',
          dataIndex: 'whystr',
        },
        {
          title: '取消原因',
          align: 'center',
          dataIndex: 'cancelmemo',
        },
        {
          title: '签到时间',
          align: 'center',
          dataIndex: 'signInTime',
        },
        {
          title: '签离时间',
          align: 'center',
          dataIndex: 'signOutTime',
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: "center",
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        list: '/visitor/base/visitorWithSiYang/list',
        delete: '/visitor/base/visitor/delete',
        deleteBatch: '/visitor/base/visitor/deleteBatch',
        exportXlsUrl: '/visitor/base/visitor/exportXls',
        visitorSignIn: '/visitor/base/visitorWithSiYang/visitorSignIn',
        visitorSignOut: '/visitor/base/visitorWithSiYang/visitorSignOut',
        checkVisitorCode: '/visitor/base/visitorWithSiYang/checkVisitorCode',
      },
      dictOptions: {},
      cancelReason: '',
      crModalvisible: false,
      crConfirmLoading: false,
      headers: {
        'X-Access-Token': token,
      },
      queryParam: {
        docstatus: '',
      },
      signInFlag: false,
      signOutFlag: false,
      curVisitorId: '',
      curVisitorName: '',
      lineChartDate: [],
      showDate: [
        moment(moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ],
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    rowSelection() {
      const { selectedRowKeys, onSelectChange } = this
      return {
        fixed: true,
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.docstatus !== 50 && record.docstatus !== 0,
          },
        }),
      }
    },
  },
  mounted() {
    this.lineChartDate[0] = moment(new Date()).format('YYYY-MM-DD')
    this.lineChartDate[1] = moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD')
    this.loadData()
    this.getUserAuthority()
    this.getdatalist()
  },
  methods: {
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    getAvatar() {
      return this.avatar()
    },
    changeDate(dates, dateStrings) {
      this.showDate = dates
      this.lineChartDate[0] = dateStrings[0]
      this.lineChartDate[1] = dateStrings[1]
      // this.lineChartChooseTypeOne = ''
      this.loadData()
      // this.getAllCount()
    },
    searchQueryToday() {
      console.log(1111111111)
      this.lineChartDate[0] = moment(new Date()).format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD')

      ;(this.showDate = [
        moment(moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ]),
        this.loadData(1)
    },
    searchQuery() {
      // console.log(1111111111)
      // this.lineChartDate[0] = moment(new Date()).format('YYYY-MM-DD')
      // this.lineChartDate[1] = moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD')
      // this.queryParam.docstatus = ''
      this.loadData()
    },
    searchReset() {
      this.queryParam = {}
      this.createTime = {}
      this.queryParam.docstatus = ''
      ;(this.showDate = [
        moment(moment(new Date()).subtract(0, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ]),
        this.loadData(1)
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      console.log('this.lineChartDate[1]', this.lineChartDate[1])
      this.queryParam.docdate_begin = this.lineChartDate[0]
      this.queryParam.docdate_end = this.lineChartDate[1]
      var params = this.getQueryParams() //查询条件
      this.loading = true
      this.dataSource = []
      console.log('params', params)
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    getUserAuthority() {
      getUserAuthority().then((res) => {
        console.log('res:', res)
        if (res.code === 200) {
          if (res.result.userRoles.length > 0) {
            // console.log('有泗阳门岗权限')
            // this.$router.replace({ name: 'VisitorListSiYang' })
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getdatalist() {
      getVisitorConfigList().then((res) => {
        console.log('res')
        console.log(res)
        if (res.code == 200) {
          let configArr = res.result.map((item) => {
            return {
              key: item.switchCode,
              value: item.switchStatus === '0' ? true : false,
            }
          })
          //配置数组转为对象 方便查询
          let obj = {}
          configArr.forEach((element) => {
            obj[element.key] = element.value
          })
          console.log(configArr)
          console.log(obj)
          this.setVisitorConfig(obj)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    //根据验证码确认签到或签离
    checkVisitorCode() {
      let params = {
        code: this.queryParam.visitorCode.substring(1, this.queryParam.visitorCode.length - 1),
      }
      console.log(params)
      getAction(this.url.checkVisitorCode, params).then((res) => {
        console.log('111111:', res)
        if (res.code === 200 && res.success) {
          this.curVisitorId = res.result.id
          this.curVisitorName = res.result.bkname
          if (res.result.states === '已提交') {
            this.signInFlag = true
            this.signOutFlag = false
            this.signIn()
            return
          }
          if (res.result.states === '已到访') {
            this.signInFlag = false
            this.signOutFlag = true
            this.signOut()
            return
          }
        } else {
          this.$message.warning(res.message)
          this.signInFlag = false
          this.signOutFlag = false
        }
      })
    },
    //签到
    signIn() {
      const that = this
      this.$antdConfirm({
        title: `该访客【${that.curVisitorName}】已预约，是否签到?`,
        content: '',
        okText: '签到',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          let params = {
            id: that.curVisitorId,
          }
          getAction(that.url.visitorSignIn, params).then((res) => {
            if (res.code === 200 && res.success) {
              that.loadData()
              that.signInFlag = false
              that.signOutFlag = false
              that.queryParam.visitorCode = ''
              that.$message.success('签到成功')
            } else {
              that.$message.warning(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    //签离
    signOut() {
      const that = this
      this.$antdConfirm({
        title: `该访客【${that.curVisitorName}】已签到，是否签离?`,
        content: '',
        okText: '签离',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          let params = {
            id: that.curVisitorId,
          }
          getAction(that.url.visitorSignOut, params).then((res) => {
            if (res.code === 200 && res.success) {
              that.loadData()
              that.signInFlag = false
              that.signOutFlag = false
              that.queryParam.visitorCode = ''
              that.$message.success('签离成功')
            } else {
              that.$message.warning(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    async downloadTemplate() {
      ajaxGetDictItems('visitor_hd_import_temp', null).then((res) => {
        window.location.href = res.result[0].value
      })
    },
    initDictConfig() {},
    handleAdd: function () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    handleCancelClick() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请先选中取消拜访的访客')
        return
      }
      this.cancelReason = ''
      this.crModalvisible = true
    },
    handleCROk() {
      if (!this.cancelReason) {
        this.$message.error('请输入取消的原因')
        return
      }
      this.crConfirmLoading = true
      cancelVistors({
        cancellationReason: this.cancelReason.trim(),
        doccodeArrStr: this.selectedRowKeys.join(','),
      })
        .then((res) => {
          if (res.success === true) {
            this.$message.success('取消成功')
            this.crModalvisible = false
          } else {
            this.$message.success(res.message)
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.$message.error(err.message)
          }
        })
        .finally(() => {
          this.crConfirmLoading = false
        })
    },
    handleCRCancel() {
      this.crModalvisible = false
      this.cancelReason = ''
    },
    handleEditNew(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '查看'
      this.$refs.modalForm.disableSubmit = true
    },
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log('1', info.file, '2', info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(info.file.response.message)
        if (info.file.response.result != '') {
          window.location.href = info.file.response.result.errorExcelUrl
        } else {
          this.searchReset()
        }
        this.$message.success(`${info.file.name}`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name}`)
      }
    },

    ...mapMutations({
      setVisitorConfig: 'SET_VISITOR_CONFIG',
    }),
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.logo {
  // width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  margin: -24px -24px 30px -24px;
  padding: 10px 20px;
  background-color: #1890ff;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(1) {
    width: 260px;
  }
  & > *:nth-child(2) {
    width: 260px;
  }
  & > *:nth-child(n) {
    margin-left: 12px;
  }
  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }
}
.table-operator {
  margin-top: 30px;
  display: flex;
}
</style>
